export default "__VITE_ASSET__FRw9lom8__"